module.exports = __webpack_public_path__ + "static/img/7.c81ce52.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/7.png
// module id = cty1
// module chunks = 4